export const __API_URL__ = process.env.REACT_APP_BACKEND_URL;
